import { colors } from '../../colors';
var location = {
  bgColor: colors.alabaster,
  cardBgColor: colors.white,
  secondaryBgColor: colors.white,
  cardShadow: colors.black
};
export default location;